import Policy from './Policy/Policy';
import ManagePoliciesForm from './ManagePoliciesForm';
import Funds from './Funds/Funds';
import Fund from './Funds/Fund';
import Charges from './Charges/Charges';
import Charge from './Charges/Charge';

export const ManagePoliciesForms = {
  Policy,
  Form: ManagePoliciesForm,
  Charges,
  Charge,
  Funds,
  Fund
};
